




































































import { inject } from 'inversify-props'
import API from '@core/services/API'
import { Component, Vue } from 'vue-property-decorator'
import AppDatatable from '@core/components/AppDatatable.vue'
import AppForm from '@core/components/AppForm.vue'
import { FormStructure } from '@master/model/structure/FormStructure'
import { IDateService } from '@master/services/IDateService'
import { header } from '@core/model/common/UserCPDMeta'
import { UserCPDMetaList } from '@core/model/common/UserCPDMetaList'
import { RequiredHours } from '@core/model/common/RequiredHours'
import { camelCase } from 'lodash/fp'
import { downloadCSVFile } from '@core/services/CSVService'
import { UIService } from '@core/services/UIService'
import { SharedVariable } from '@core/model/SharedVariable'
import { IProjectSettings } from '@master/config/IProjectSettings'
import AppDialog from '@core/components/AppDialog.vue'

@Component({
  components: {
    AppDatatable,
    AppForm,
    AppDialog
  }
})
export default class UserCpdRecords extends Vue {
  @inject()
  protected $api: API

  uiService: UIService

  @inject()
  private sharedVariable: SharedVariable

  @inject()
  protected dateService: IDateService

  @inject()
  protected projectSettings: IProjectSettings

  protected userCPDMetaList: UserCPDMetaList = null
  protected requiredHours: RequiredHours = new RequiredHours()
  protected globalRequiredHours: RequiredHours = new RequiredHours('global_cpd_req')
  protected showModal = false

  formattedDate (unixTime: number) {
    return this.dateService.format(Number(unixTime), 'YYYY-MM-DD')
  }

  get userOid (): string {
    return this.$route.params.userOid as string || this.$store.getters.currentUser.accountID
  }

  get list () {
    return !this.userCPDMetaList ? [] : this.userCPDMetaList.list.map(cpd => {
      cpd.faCoreEthicsHours = cpd.faCoreEthicsHours ?? 0
      cpd.faCoreRegHours = cpd.faCoreRegHours ?? 0
      cpd.faSuppMsHours = cpd.faSuppMsHours ?? 0
      cpd.faSuppOthersHours = cpd.faSuppOthersHours ?? 0
      cpd.giOthers = cpd.giOthers ?? 0

      return this.isOpsStaff ? {
        ...cpd,
        startDateMillis: this.formattedDate(cpd.startDateMillis),
        endDateMillis: this.formattedDate(cpd.endDateMillis),
        presentString: cpd.present === 1 ? 'Yes' : 'No',
        redirect: '/live/cpd/course/' + cpd.courseId
      } : {
        ...cpd,
        startDateMillis: this.formattedDate(cpd.startDateMillis),
        endDateMillis: this.formattedDate(cpd.endDateMillis),
        presentString: cpd.present === 1 ? 'Yes' : 'No'
      }
    })
  }

  get columns () {
    return [
      { label: 'Course Title', field: 'courseTitle' },
      { label: 'From', field: 'startDateMillis' },
      { label: 'To', field: 'endDateMillis' },
      { label: 'FA Core Ethics Hours', field: 'faCoreEthicsHours' },
      { label: 'FA Core Reg Hours', field: 'faCoreRegHours' },
      { label: 'FA Supp MS Hours', field: 'faSuppMsHours' },
      { label: 'FA Supp Others Hours', field: 'faSuppOthersHours' },
      { label: 'GI Hours', field: 'giOthers' },
      { label: 'Assigned To', field: 'assignedTo' },
      { label: 'Present', field: 'presentString' }
    ]
  }

  sumHours () {
    const result = {}
    this.list.forEach(cpd => {
      if (!(cpd.assignedTo in result) && (cpd.present)) {
        result[cpd.assignedTo] = {
          assignedTo: cpd.assignedTo,
          faCoreEthicsHours: cpd.faCoreEthicsHours,
          faCoreRegHours: cpd.faCoreRegHours,
          faSuppMsHours: cpd.faSuppMsHours,
          faSuppOthersHours: cpd.faSuppOthersHours,
          giOthers: cpd.giOthers
        }
      } else if (!(cpd.assignedTo in result) && !(cpd.present)) {
        result[cpd.assignedTo] = {
          assignedTo: cpd.assignedTo,
          faCoreEthicsHours: 0,
          faCoreRegHours: 0,
          faSuppMsHours: 0,
          faSuppOthersHours: 0,
          giOthers: 0
        }
      } else if (cpd.assignedTo in result && cpd.present) {
        result[cpd.assignedTo].faCoreEthicsHours += cpd.faCoreEthicsHours
        result[cpd.assignedTo].faCoreRegHours += cpd.faCoreRegHours
        result[cpd.assignedTo].faSuppMsHours += cpd.faSuppMsHours
        result[cpd.assignedTo].faSuppOthersHours += cpd.faSuppOthersHours
        result[cpd.assignedTo].giOthers += cpd.giOthers
      }
    })
    return result
  }

  get hoursList () {
    return Object.entries(this.sumHours()).map(data => {
      return data[1]
    })
  }

  get hoursColumns () {
    return [
      { label: 'Year', field: 'assignedTo' },
      { label: 'FA Core Ethic Hours', field: 'faCoreEthicsHours' },
      { label: 'FA Core Reg Hours', field: 'faCoreRegHours' },
      { label: 'FA Supp MS Hours', field: 'faSuppMsHours' },
      { label: 'FA Supp Others Hours', field: 'faSuppOthersHours' },
      { label: 'GI', field: 'giOthers' }
    ]
  }

  get currentUser () {
    return this.$store.getters.currentUser
  }

  mapRawKeytoFormatKey (list: string[]) {
    return list.map(key => {
      return camelCase(key)
    })
  }

  exportCSV () {
    const column = this.mapRawKeytoFormatKey(header)
    downloadCSVFile(column, this.list, 'cpd-summary')
  }

  exportCSVHours () {
    const headerHours = [
      'Year',
      'FA Core Ethic Hours',
      'FA Core Reg Hours',
      'FA Supp MS Hours',
      'FA Supp Others Hours',
      'GI'
    ]
    const column = this.mapRawKeytoFormatKey(headerHours)
    downloadCSVFile(column, this.hoursList, 'cpd-cumulated-hours')
  }

  get structure (): FormStructure<RequiredHours> {
    return [
      {
        label: 'Year',
        key: 'year',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'FA Core Ethics Hours',
        key: 'ethics',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'FA Core Reg Hours',
        key: 'reg',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'FA Supp MS Hours',
        key: 'suppMs',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'FA Supp Others Hours',
        key: 'suppOthers',
        type: 'number',
        disabled: !this.isOpsStaff
      },
      {
        label: 'GI',
        key: 'gi',
        type: 'number',
        disabled: !this.isOpsStaff
      }
    ]
  }

  get isOpsStaff () {
    return this.currentUser.systemrole === 'ops-staff'
  }

  async setToDefault () {
    await this.getDefaultHours()
    this.requiredHours.year = this.globalRequiredHours.year
    this.requiredHours.ethics = this.globalRequiredHours.ethics
    this.requiredHours.reg = this.globalRequiredHours.reg
    this.requiredHours.suppMs = this.globalRequiredHours.suppMs
    this.requiredHours.suppOthers = this.globalRequiredHours.suppOthers
    this.requiredHours.gi = this.globalRequiredHours.gi
  }

  openModal () {
    this.showModal = true
  }

  async save () {
    /* eslint-disable @typescript-eslint/camelcase */
    const keys = ['year', 'ethics', 'reg', 'suppMs', 'suppOthers', 'gi']
    const data = {
      adviser_oid: this.userOid,
      data: JSON.stringify(this.requiredHours.convertToCustomRawData(keys))
    }
    /* eslint-enable */

    await this.$api.cpd.save(data)
    await this.uiService.alert.show({
      type: 'success',
      message: 'Save Successful'
    })
    this.showModal = false
    await this.fetchData()
  }

  async getDefaultHours () {
    const hoursHeader = [
      'global_cpd_req_year',
      'global_cpd_req_ethics',
      'global_cpd_req_reg',
      'global_cpd_req_supp_ms',
      'global_cpd_req_supp_others',
      'global_cpd_req_gi'
    ]

    const res = await this.$api.cpd.getHours({
      keys: JSON.stringify(hoursHeader)
    })
    Object.assign(this.globalRequiredHours, this.globalRequiredHours.extractData(res.values))
  }

  async fetchData () {
    // Fetch Course Participated data
    const res = await this.$api.cpd.list({
      query: 'user_oid = ?',
      queryArgs: JSON.stringify([this.userOid || 'new']),
      headers: JSON.stringify(header)
    })
    this.userCPDMetaList = new UserCPDMetaList(res.data)

    // Fetch Required Hours data
    /* eslint-disable @typescript-eslint/camelcase */
    const resDetail = await this.$api.cpd.getDetails({
      adviser_oid: this.userOid
    })
    /* eslint-enable */
    if (resDetail.data && resDetail.data.req_year) {
      Object.assign(this.requiredHours, this.requiredHours.extractData(resDetail.data))
    } else {
      await this.getDefaultHours()
    }
  }

  get learningManagementModuleStatus () {
    return this.projectSettings.learningManagementModule?.enable
  }

  redirectToAcadle () {
    window.open(this.projectSettings.learningManagementModule.url)
  }

  async mounted () {
    // take injected UIService and set it to local
    this.uiService = this.sharedVariable.uiService

    await this.fetchData()
  }
}
